import React from "react";

const Logo = (props) => (
  <svg
    viewBox="0 0 1080 1080"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    <defs>
      <linearGradient id="mainGradient" gradientUnits="userSpaceOnUse" x1="282.3446" y1="189.4304" x2="639.0783" y2="807.3113">
        <stop offset="0" stopColor="#D69C47" />
        <stop offset="0.2352" stopColor="#FFE791" />
        <stop offset="0.3229" stopColor="#E6BA63" />
        <stop offset="0.3893" stopColor="#D69C47" />
        <stop offset="0.5338" stopColor="#ECC775" />
        <stop offset="0.6687" stopColor="#FFEC9F" />
        <stop offset="0.8123" stopColor="#BF9B50" />
        <stop offset="0.954" stopColor="#8C5F1C" />
        <stop offset="1" stopColor="#D69C47" />
      </linearGradient>
    </defs>
    <path
      fill="url(#mainGradient)"
      d="M228.32,220.62C358.87,344.92,383.22,471.69,372.2,588.5c92.3-9.57,210.08-3.7,327.12,56.88
        c0,0-153.29-34.49-339.54,22.64c-11.33,49.76-27.28,91.26-39.96,119.63c0,0,360.52,72.76,531.85-123.64
        C694.07,228.79,228.32,220.62,228.32,220.62z"
    />
  </svg>
);

export default Logo;
